export type Role = 'Admin' | 'HCP';
export const roles = {
    Admin: "Admin" as Role,
    HCP: 'HCP' as Role,
};
